import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyDepartmentsPage from './Page';
import type { TaxonomyDepartment } from '../../../types/uncinc_profile/taxonomy';

interface DepartmentsProps {
  entity: ImmutableEntity<TaxonomyDepartment>;
}

const TaxonomyDepartmentsWrapper: React.FC<DepartmentsProps> = ({ entity, ...props }) => (
  <TaxonomyDepartmentsPage entity={entity} {...props} />
);

export default TaxonomyDepartmentsWrapper;
